import { useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

function useAutoCheckout(build) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const started = useRef(false);
  useEffect(() => {
    if (loading || started.current) return;
    started.current = true;
    if (!user) { navigate("/login"); return; }
    (async () => {
      try {
        const payload = build();
        if (!payload) return;
        const { data } = await api.post("/payments/checkout", payload);
        window.location.href = data.checkout_url;
      } catch (e) {
        toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not start checkout");
        navigate(user.role === "employer" ? "/employer" : user.role === "admin" ? "/admin" : "/applicant");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, loading]);
}

const Spinner = ({ label }) => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
    <Loader2 className="h-9 w-9 animate-spin text-amber-500" />
    <p className="text-slate-500 font-medium">{label}</p>
  </div>
);

export function RenewJob() {
  const { jobId } = useParams();
  useAutoCheckout(() => ({ lookup_key: "employer_job_post", origin_url: window.location.origin, purpose: "renew", job_id: jobId }));
  return <Spinner label="Taking you to your renewal checkout…" />;
}

export function RenewMembership() {
  useAutoCheckout(() => ({ lookup_key: "applicant_membership", origin_url: window.location.origin, purpose: "membership" }));
  return <Spinner label="Taking you to your membership renewal…" />;
}
